import { makeAutoObservable } from "mobx";
import def from "./def";
import p_msDwnlDump from "./ms_dwnl_dump";
import tnk_msState from "./ms_state";
import tnk_msStat from "./ms_stat";
import tnk_genTgKey from "./gen_tg_key";
import tnk_loadJSON from "./load_json";
import tnk_allPush from "./all_push";
import tnk_msAllowMany from "./allow_many";

class Data {
	s = {
		def,
		p_msDwnlDump,
		tnk_msState,
		tnk_msStat,
		tnk_genTgKey,
		tnk_loadJSON,
		tnk_allPush,
		tnk_msAllowMany,
	};
	constructor(props) {
		makeAutoObservable(this);
	}
}

const data = new Data();
export default data;
